// extracted by mini-css-extract-plugin
export var arrows = "_46-6";
export var decrementer = "_46-a";
export var disabled = "_46-4";
export var error = "_46-1";
export var hiddenText = "_46-b";
export var incrementer = "_46-9";
export var input = "_46-8";
export var inputWrapper = "_46-0";
export var leadingIcon = "_46-c";
export var readonly = "_46-3";
export var regular = "_46-7";
export var small = "_46-5";
export var warning = "_46-2";